import { useAppStore } from '../store/useAppStore';
import { ILoadingService } from './ILoadingService';

export class LoadingServiceImpl implements ILoadingService {
  private appStore: typeof useAppStore;

  public constructor(appStore: typeof useAppStore) {
    this.appStore = appStore;
  }

  public showLoadContainer(type: 'OPAQUE' | 'TRANSPARENT'): void {
    this.appStore.getState().loadContainer.setShowLoadContainer(true);
    this.appStore.getState().loadContainer.setLoadContainerType(type);
  }

  public hideLoadContainer(): void {
    this.appStore.getState().loadContainer.setShowLoadContainer(false);
  }
}
